/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VolunteerSearchResult } from './VolunteerSearchResult';
import {
    VolunteerSearchResultFromJSON,
    VolunteerSearchResultFromJSONTyped,
    VolunteerSearchResultToJSON,
    VolunteerSearchResultToJSONTyped,
} from './VolunteerSearchResult';

/**
 * 
 * @export
 * @interface SearchResultsOfVolunteerSearchResult
 */
export interface SearchResultsOfVolunteerSearchResult {
    /**
     * 
     * @type {Array<VolunteerSearchResult>}
     * @memberof SearchResultsOfVolunteerSearchResult
     */
    data: Array<VolunteerSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultsOfVolunteerSearchResult
     */
    hasMoreItems: boolean;
}

/**
 * Check if a given object implements the SearchResultsOfVolunteerSearchResult interface.
 */
export function instanceOfSearchResultsOfVolunteerSearchResult(value: object): value is SearchResultsOfVolunteerSearchResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('hasMoreItems' in value) || value['hasMoreItems'] === undefined) return false;
    return true;
}

export function SearchResultsOfVolunteerSearchResultFromJSON(json: any): SearchResultsOfVolunteerSearchResult {
    return SearchResultsOfVolunteerSearchResultFromJSONTyped(json, false);
}

export function SearchResultsOfVolunteerSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultsOfVolunteerSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(VolunteerSearchResultFromJSON)),
        'hasMoreItems': json['hasMoreItems'],
    };
}

export function SearchResultsOfVolunteerSearchResultToJSON(json: any): SearchResultsOfVolunteerSearchResult {
    return SearchResultsOfVolunteerSearchResultToJSONTyped(json, false);
}

export function SearchResultsOfVolunteerSearchResultToJSONTyped(value?: SearchResultsOfVolunteerSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(VolunteerSearchResultToJSON)),
        'hasMoreItems': value['hasMoreItems'],
    };
}

